// The one MapLibre map, as a live binding.
//
// `map` was a bare `let` at the top of app.ts, which is a large part of why
// nothing could leave app.ts: the layer builders, the sprite generator, the
// hover handling and the layout code all reach for it, and a module that cannot
// see it cannot move out.
//
// Exporting a `let` gives importers a LIVE binding — they see whatever `setMap`
// last stored, not a copy taken at import time. So `import { map } from
// './instance.ts'` then `map.getCenter()` reads correctly, and the ~100 existing
// call sites keep their spelling instead of becoming `getMap().getCenter()`.
//
// It is deliberately not initialised at declaration: nothing may touch the map
// before initMap has built it, and leaving it undefined makes that a loud
// failure rather than a silent one against a half-built object.

import type { Map as MapLibreMap } from 'maplibre-gl';

export let map: MapLibreMap;

export function setMap(m: MapLibreMap): void {
  map = m;
}

// Has the map been built yet? A handful of callers run before initMap — the
// breakpoint listener fires on a media-query change that can beat the map into
// existence — and they check rather than assume.
export function hasMap(): boolean {
  return typeof map !== 'undefined' && !!map;
}
